/**
 * Click-to-Call und Click-to-Mail-Helfer.
 *
 * Wandelt Display-Telefonnummern aus der DB in saubere tel:-URLs um.
 * Auf macOS oeffnet das den Anruf-Dialog (Handoff aufs iPhone, wenn
 * die Continuity-Anrufe aktiviert sind).
 *
 * Normalisierungsregeln:
 *   - Beginnt die Nummer mit '+', wird sie nur von Sonderzeichen
 *     bereinigt (Auslandsnummern bleiben respektiert).
 *   - Beginnt die Nummer mit einer einzelnen '0', wird daraus '+49'
 *     (deutscher Standardfall, sowohl Festnetz als auch Mobil).
 *   - Alles andere wird unveraendert durchgereicht (Best Effort).
 *   - Leer / null -> null (keine Verlinkung).
 */
export function formatTelHref(raw) {
  if (!raw) return null;
  // Alles ausser Ziffern und fuehrendem '+' raus.
  const trimmed = String(raw).trim();
  let nur = trimmed.replace(/[^\d+]/g, '');
  if (!nur) return null;
  if (nur.startsWith('+')) {
    return `tel:${nur}`;
  }
  if (nur.startsWith('00')) {
    // 0049 -> +49 (alte Auslandsschreibweise)
    return `tel:+${nur.slice(2)}`;
  }
  if (nur.startsWith('0')) {
    return `tel:+49${nur.slice(1)}`;
  }
  // Notfall — Nummer ohne Vorwahl-Indikator (nehmen wir als-ist)
  return `tel:${nur}`;
}

export function formatMailHref(raw) {
  if (!raw) return null;
  const e = String(raw).trim();
  if (!e || !e.includes('@')) return null;
  return `mailto:${e}`;
}

/**
 * Erkennt offensichtliche Platzhalter-Mail-Adressen, die kein echter
 * Empfaenger sind. Wird vor dem Mail-Versand benutzt, damit das System
 * nicht versucht, an Test-Adressen zu schreiben (Mailserver lehnt
 * example.com per RFC ab).
 *
 * Erfasst:
 *   - leer / kein '@'
 *   - 'not_needed@*' (Booking-Widget-Platzhalter fuer Hausbesuch-Kunden,
 *     die nur per Post / Telefon erreichbar sind)
 *   - 'noreply@*' / 'no-reply@*' (One-Way-Adressen)
 *   - RFC-reservierte Test-Domains: example.com, example.org, example.net,
 *     test.de, test.com, *.invalid
 */
export function istPlatzhalterEmail(raw) {
  if (!raw) return true;
  const e = String(raw).trim().toLowerCase();
  if (!e || !e.includes('@')) return true;
  if (e.startsWith('not_needed@')) return true;
  if (e.startsWith('noreply@') || e.startsWith('no-reply@')) return true;
  const domain = e.split('@').pop();
  const platzhalterDomains = new Set([
    'example.com', 'example.org', 'example.net',
    'test.de', 'test.com', 'invalid',
  ]);
  if (platzhalterDomains.has(domain)) return true;
  if (domain && domain.endsWith('.invalid')) return true;
  return false;
}
